import { promptLogin } from '@/services/app/mcd';
import { Login as LoginLayout } from '@CS/routes';

type LoginProps = {
  onLogin: () => void;
  onError?: (error: Error) => void;
};

export const Login = ({ onLogin, onError }: LoginProps) => {
  const onClick = () =>
    promptLogin()
      .then(() => onLogin())
      .catch((error) => onError?.(error));

  return <LoginLayout onLogin={onClick} />;
};
